import { useNavigate, useParams, Link } from "react-router-dom";
import { ChevronRight, ArrowRight } from "lucide-react";
import { GoldButton } from "@/components/site/ui";
import { useFetch } from "@/lib/useFetch";
import { buyService } from "@/lib/cart";
import { useSeo } from "@/lib/seo";

export default function BlogPost() {
    const { slug } = useParams();
    const nav = useNavigate();
    const { data: p, loading } = useFetch(`/blog/${slug}`);
    useSeo(p ? { title: `${p.title} | SUDIGI`, description: p.excerpt } : { title: "Article | SUDIGI" });
    if (loading) return <div className="min-h-[60vh] grid place-items-center text-cream-soft">Loading…</div>;
    if (!p) return <div className="min-h-[60vh] grid place-items-center text-cream-soft">Article not found.</div>;
    const go = () => { if (p.cta_service) buyService(p.cta_service); nav("/checkout"); };
    return (
        <article className="bg-teal-900 py-14 min-h-[70vh]">
            <div className="container-x max-w-3xl">
                <nav className="flex items-center gap-1.5 text-xs text-cream-soft/70 mb-6">
                    <Link to="/resources" className="hover:text-gold">Resources</Link><ChevronRight className="w-3 h-3" /><span className="text-cream">{p.category}</span>
                </nav>
                <span className="text-xs font-semibold text-gold uppercase tracking-wide">{p.category}</span>
                <h1 className="font-serif text-4xl text-cream mt-2 leading-tight">{p.title}</h1>
                <p className="text-sm text-cream-soft/70 mt-3">By {p.author}</p>
                <div className="mt-8 text-cream-soft leading-relaxed text-[15px] whitespace-pre-line">{p.content}</div>
                <div className="mt-10 card-teal rounded-2xl p-7 text-center bg-gradient-to-br from-teal-700 to-teal-800 border border-gold/30">
                    <p className="font-serif text-2xl text-cream">{p.cta_text}</p>
                    <GoldButton onClick={go} className="mt-5 !px-8" data-testid="blog-cta">Get Started <ArrowRight className="w-4 h-4" /></GoldButton>
                </div>
            </div>
        </article>
    );
}
